// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { N800 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { Flex } from '@atlassian/eoc-flex';

import { LAYER_HEIGHT } from '../../../../common/constants';
import { WIDTH as SideBarWidth } from '../../../../common/ui/side-container/styled';

const HEADER_HEIGHT = token('space.400', '32px');
const HEADER_BOTTOM = token('space.200', '16px');

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Container = styled.div({
	display: 'flex',
	flexDirection: 'column',
	height: '100%',
	overflowY: 'auto',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `calc(100% - ${SideBarWidth}px)`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ScrollableArea = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	minWidth: `${1024 - SideBarWidth}px`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const HeaderContainer = styled(Flex)({
	margin: `0 0 ${HEADER_BOTTOM} 0`,
	minHeight: HEADER_HEIGHT,
	maxHeight: HEADER_HEIGHT,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const LayerName = styled.h6({
	color: token('color.text.subtle', N800),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: LAYER_HEIGHT,
	padding: `0 0 ${token('space.050', '4px')} 0`,
});

// FIX: Padding is added because when calendar is show right side is cut off
// TODO: probably there should box shadow for top and bottom when there is something to scroll to
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Scrollable = styled.div({
	flex: '1 1 auto',
	height: '100%',
	overflowY: 'auto',
	overflowX: 'hidden',
	paddingRight: token('space.025', '2px'),
});
